<template>
  <div class="form-field form-address"
       v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-readonly': readOnly, 'has-lang': lang, 'form-disabled':isDisabled}">
    <div class="form-label" v-show="label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">

      <!--
      Value: {{ internalValue == null ? "Null" : internalValue }}<br>
      Preview: {{ previewMode }}
      -->

      <div class="form-input-wrapper" style="border: 0px;">

        <div class="notice wraning" v-if="internalValue && internalValue.accept_partial_match == '1'">L'adresse semble invalide pour Google</div>

        <form-select-new
            v-show="internalValue == null || internalValue == {}"
            v-if="options && options.length"
            label=""
            v-model="selectionOfAddress"
            :options="options"
            :callback="changeAddress"></form-select-new>

        <div class="address-preview" v-show="previewMode" v-if="internalValue || (options && options.length <= 0)">
          <div v-if="internalValue">
            <span v-if="internalValue.company">{{ internalValue.company }}</span>
            <span v-if="internalValue.firstname || internalValue.lastname">{{
                internalValue.firstname
              }} {{ internalValue.lastname }}</span>
            <span>{{ internalValue.street }} {{ internalValue.street_number }}</span>
            <span v-if="internalValue.street_complement">{{ internalValue.street_complement }}</span>
            <span>{{ internalValue.postal_code }} {{ internalValue.locality }}</span>
            <span>{{
                internalValue.country && internalValue.country.name ? internalValue.country.name : internalValue.country
              }}</span>

            <span v-if="internalValue && internalValue.lat != 0 && internalValue.lng != 0" style="display: block;margin-top: 1em;">
              <i class="icon icon-icon_location"></i> {{ internalValue.lat }}, {{ internalValue.lng }}
            </span>

            <button class="action-link" style="margin-top: 1em;" @click="validateAddress">
              <i class="icon icon-icon_location"></i>
              <span>Vérifier l'adresse sur Google</span>
            </button>
          </div>

          <div class="actions" v-if="!isDisabled">
            <button @click="toggleEdition" class="bt-edit"><i class="icon icon-icon_pencil"></i></button>
            <button @click="removeAddress" class="bt-remove"><i class="icon icon-icon_delete"></i></button>
          </div>
        </div>

        <div class="form-input-container" v-show="!previewMode" v-if="internalValue != null">
          <div class="form-input-wrapper" rel="company">
            <input type="text" value="" v-model="internalValue.company" placeholder="company"/>
          </div>
          <div class="form-input-wrapper" rel="firstname">
            <input type="text" value="" v-model="internalValue.firstname" placeholder="firstname"/>
          </div>
          <div class="form-input-wrapper" rel="lastname">
            <input type="text" value="" v-model="internalValue.lastname" placeholder="lastname"/>
          </div>
          <div class="form-input-wrapper" rel="street">
            <input type="text" value="" v-model="internalValue.street" placeholder="street"/>
          </div>
          <div class="form-input-wrapper" rel="street_number">
            <input type="text" value="" v-model="internalValue.street_number" placeholder="n°"/>
          </div>
          <div class="form-input-wrapper" rel="street_complement">
            <input type="text" value="" v-model="internalValue.street_complement" placeholder="Complement"/>
          </div>
          <div class="form-input-wrapper" rel="postal_code">
            <input type="text" value="" v-model="internalValue.postal_code" placeholder="Zipcode"/>
          </div>
          <div class="form-input-wrapper" rel="locality">
            <input type="text" value="" v-model="internalValue.locality" placeholder="City"/>
          </div>
          <div class="form-input-wrapper" rel="country">
            <form-select label="" multiple="false" v-model="internalValue.country"
                         :default="internalValue.country_id ? internalValue.country_id : internalValue.country"
                         :options="$store.state.countries"></form-select>
          </div>

          <button @click="validateAddress" class="action-link" style="margin-top: 1em;">
            <i class="icon icon-icon_location"></i>
            <span>Vérifier l'adresse sur Google</span>
          </button>

          <div class="actions" v-if="!isDisabled">
            <button @click="toggleEdition" class="bt-edit"><i class="icon icon-icon_tick"></i></button>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import ScopeService from '../../modules/scope/ScopeService.js';

export default {
  name: 'FormField',
  props: ['value', 'label', 'options', 'name', 'placeholder', 'suffix', 'lang', 'required', 'readonly', 'maxlength', 'callback', 'disabled'],
  data: function () {
    return {
      internalValue: null,
      langClass: "",
      previewMode: true,
      selectionOfAddress: null,
      ScopeService: null
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.langClass = this.lang ? "flag lang-" + this.lang : "";
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.readOnly = this.readonly && (this.readonly == 'true' || this.readonly == true) ? true : false
    this.onChange = this.callback ? true : false;
    this.ScopeService = ScopeService;
    this.setDisabled(this.disabled)
    //console.log("Init address", this.value)
  },
  methods: {
    validateAddress: function(){
      ScopeService.validateAddress(this.internalValue).then(response => {
        let ask = confirm("Voici l'adresse correspondante, souhaitez-vous la remplacer ?\n\n" + response.data.street + " "+ response.data.street_number + "\n" + response.data.postal_code + " " + response.data.locality)
        if( ask ){
          this.internalValue.street = response.data.street;
          this.internalValue.street_number = response.data.street_number;
          this.internalValue.postal_code = response.data.postal_code;
          this.internalValue.locality = response.data.locality;
          this.internalValue.lat = response.data.lat;
          this.internalValue.lng = response.data.lng;

          if( this.internalValue.street_number.trim() == this.internalValue.street_complement.trim() || response.data.street_number.trim() == this.internalValue.street_complement.trim() )
          {
            this.internalValue.street_complement = null;
          }

          this.toggleEdition();
        }
      })
      return false;
    },
    empty: function () {
      return {
        company: null,
        firstname: null,
        lastname: null,
        street: null,
        street_number: null,
        street_complement: null,
        postal_code: null,
        locality: null,
        country: null
      }
    },
    removeAddress: function () {
      //alert(this.label)
      this.selectionOfAddress = null
      this.internalValue = null
      this.previewMode = true
      //this.$forceUpdate()
    },
    changeAddress: function (address) {
      if (address && address.id) {
        this.internalValue = address
        this.selectionOfAddress = null
      }

      this.$forceUpdate()
    },
    toggleEdition: function () {
      this.previewMode = !this.previewMode

      if (!this.previewMode) {
        this.internalValue = this.internalValue ? this.internalValue : this.empty()
      }

      if (this.onChange) {
        this.callback(this.internalValue)
      }

    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'options'(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        //console.log("options: " + this.label, 'watch change')
        this.options = newVal
        //this.setDefault(this.default);
      }
    },
    'value'(newVal, oldVal) {
      console.log("$WATCH INIT ADDRESS COMPONENT: " + this.label)
      if (newVal && JSON.stringify(newVal) != JSON.stringify(oldVal)) {

        //console.log("value: " + this.label, JSON.stringify(newVal), JSON.stringify(oldVal))
        newVal = newVal instanceof Array ? {} : newVal;
        this.internalValue = newVal
        this.selectionOfAddress = newVal
        if (this.internalValue == null) {
          this.previewMode = true
          this.internalValue == {}
        }
        if (this.internalValue == {}) {
          this.previewMode = true
        }
      }
    },
    'internalValue'(newVal, oldVal) {
      console.log("$WATCH ADDRESS COMPONENT: " + this.label)
      this.$emit('input', this.internalValue);
      if (this.onChange) {
        //console.log("internalValue: " + this.label, 'watch change')
        this.callback(this.internalValue)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Address.vue